export const props = { viewBox: "0 0 20 20" };
export const innerHTML = '<circle cx="10" cy="10" r="9" stroke-width="2" fill="none" stroke="currentcolor">';
